
export default {
  // 用户信息
  setLoginUser (state, options) {
    state.loginUser = options.loginUser;
  },

  //记录是否已登录
  setLoginToken (state, options) {
    state.loginToken = options.loginToken;
  },

  //记录未登录跳转前的路由名字
  setRouteBeforeName (state, options) {
    state.routeBeforeName = options.routeBeforeName;
  },

  // 主题切换
  TOGGLE_THEME (state, data) {
    state.curTheme = data.theme;
  },

}
